import type { FC } from 'react';
import { VerificationDetailsTooltip } from './VerificationDetailsTooltip';
import { IconCertifiedWithIntercom } from './IconCertifiedWithIntercom';
import type { Verification } from './types';
import { IconMinus, IconTick, Text } from 'braid-design-system';

type QuestionnaireSubmissionStatusIconProps =
  | {
      status: string;
      hideTooltip: true;
      verifications?: Verification[];
    }
  | {
      jobApplicationId: string;
      status: string;
      hideTooltip: false;
      verifications?: Verification[];
    };

export const QuestionnaireSubmissionStatusIcon: FC<
  QuestionnaireSubmissionStatusIconProps
> = (props) => {
  const { status, hideTooltip, verifications } = props;

  if (status === 'CERTIFIED' && verifications && verifications.length > 0) {
    const verifiedIcon = (
      <Text size="small">
        <IconCertifiedWithIntercom />
      </Text>
    );
    if (hideTooltip) {
      return verifiedIcon;
    }
    return (
      <VerificationDetailsTooltip verifications={verifications}>
        {verifiedIcon}
      </VerificationDetailsTooltip>
    );
  }

  if (status === 'MATCH') {
    return (
      <Text size="small">
        <IconTick />
      </Text>
    );
  }

  return (
    <Text size="small">
      <IconMinus />
    </Text>
  );
};
